import * as React from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@fluentui/react/lib/Icon";
import { TooltipHost } from "@fluentui/react";
import { Spinner } from "@fluentui/react/lib/Spinner";

import { TEXT } from "../../../../../shared/constants/texts";
import { ICON } from "../../../../../shared/constants/icons";
import { UPLOAD_TYPE, UPLOAD_FLOW } from "../../../../../shared/constants/uploadParams";
import { hideReplaceExistingPopup, storeReplaceExistingData } from "../../../redux/slice";
import { callToUploadApi } from "../../../utils";

const ReplaceExisting: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const state = useSelector((state: any) => state.addToIciSlice);
  const { replaceExistingData } = state;
  const [paginationIndex, setPaginationIndex] = React.useState(1);
  const [isUploading, setIsUploading] = React.useState(false);
  const errorValidationMsg =
    useSelector((state: any) => state.errorValidation.validationError) ||
    JSON.parse(localStorage.getItem(TEXT.LOCAL_STORAGE_VALIDATION_MSG_KEY));
  const apiCallParams = {
    dispatch: dispatch,
    history: history,
    errorValidationMsg: errorValidationMsg,
  };

  const onLeftIconClicked = () => {
    setPaginationIndex((prevState) => prevState - 1);
  };
  const onRightIconClicked = () => {
    setPaginationIndex((prevState) => prevState + 1);
  };
  const handleReplaceData = (data) => {
    const updatedReplaceData = replaceExistingData.filter((item) => item.InternetMessageId !== data.InternetMessageId);
    if (updatedReplaceData.length === 0) {
      dispatch(hideReplaceExistingPopup());
      dispatch(storeReplaceExistingData([]));
    } else {
      dispatch(storeReplaceExistingData(updatedReplaceData));
      if (paginationIndex === replaceExistingData.length) {
        setPaginationIndex(paginationIndex - 1);
      }
    }
  };

  const onReplaceExistingClicked = () => {
    setIsUploading(true);
    const data = replaceExistingData[paginationIndex - 1];
    callToUploadApi({
      ...apiCallParams,
      state: state,
      dnd: false,
      type: UPLOAD_TYPE.REPLACE_EXISTING,
      from: "",
      flow: UPLOAD_FLOW.SINGLE_EMAIL_THREAD_UPLOAD_REPLACE_POPUP,
      uploadData: { data: data },
      onUpload: () => {
        handleReplaceData(data);
        if (replaceExistingData && replaceExistingData.length > 1) {
          setIsUploading(false);
        }
      },
    });
  };

  const onKeepBothClicked = () => {
    setIsUploading(true);
    const data = replaceExistingData[paginationIndex - 1];
    callToUploadApi({
      ...apiCallParams,
      state: state,
      dnd: true,
      type: UPLOAD_TYPE.KEEP_BOTH,
      from: "",
      flow: UPLOAD_FLOW.SINGLE_EMAIL_THREAD_UPLOAD_REPLACE_POPUP,
      uploadData: { data: data },
      onUpload: () => {
        handleReplaceData(data);
        if (replaceExistingData && replaceExistingData.length > 1) {
          setIsUploading(false);
        }
      },
    });
  };

  const onSkipClicked = () => {
    const data = replaceExistingData[paginationIndex - 1];
    handleReplaceData(data);
  };

  let subject = "";
  let alreadyExistsIn = "";
  let startIndex = paginationIndex;
  let endIndex = paginationIndex;
  let classNameLeftIcon = ICON.ICON;
  let classNameRightIcon = ICON.ICON;
  if (replaceExistingData.length > 0) {
    subject = replaceExistingData[paginationIndex - 1].AssociationDetailsOnDragDrop.InstanceName;
    alreadyExistsIn = replaceExistingData[paginationIndex - 1].AssociationDetailsOnDragDrop.AssociationName;
    startIndex = paginationIndex;
    endIndex = replaceExistingData.length;
  }
  if (replaceExistingData.length > 1) {
    if (paginationIndex === 0) {
      classNameLeftIcon = ICON.ICON_DISABLED;
    }
    if (paginationIndex === replaceExistingData.length) {
      classNameRightIcon = ICON.ICON_DISABLED;
    }
  }

  return (
    <div className="replace-existing-container-add-to-ici">
      <div className="information-container">
        <div className="email-thread">
          <div>
            <p>{TEXT.EMAIL_THREAD}</p>
          </div>
          {replaceExistingData.length > 1 ? (
            <div className="pagination-container">
              <Icon
                className={classNameLeftIcon}
                iconName={ICON.LEFT}
                onClick={classNameLeftIcon === ICON.ICON ? () => onLeftIconClicked() : () => {}}
              />
              <span className="sr-only">{TEXT.LEFT}</span>
              <p>
                {startIndex} of {endIndex}
              </p>
              <Icon
                className={classNameRightIcon}
                iconName={ICON.RIGHT}
                onClick={classNameRightIcon === ICON.ICON ? () => onRightIconClicked() : () => {}}
              />
              <span className="sr-only">{TEXT.RIGHT}</span>
            </div>
          ) : null}
        </div>
        <div className="subject">
          <TooltipHost id="subject-tooltip-add-to-ici" content={subject}>
            <p>
              ({TEXT.SUBJECT}: {subject})
            </p>
          </TooltipHost>
        </div>
        <div className="already-exists">
          <p>
            {TEXT.ALREADY_EXISTS_IN} {alreadyExistsIn}
          </p>
        </div>
      </div>
      {!isUploading ? (
        <div className="button-container">
          <button onClick={() => onReplaceExistingClicked()}>{TEXT.REPLACE_EXISTING}</button>
          <button onClick={() => onKeepBothClicked()}>{TEXT.KEEP_BOTH}</button>
          <button onClick={() => onSkipClicked()}>{TEXT.SKIP}</button>
        </div>
      ) : (
        <div className="uploading-to-ici-replace-popup-container-add-to-ici">
          <Spinner label={TEXT.UPLOADING_TO_ICI} labelPosition="right" />
        </div>
      )}
    </div>
  );
};

export default ReplaceExisting;
